APPS.shows.list = (function(){
    var show = function(options){
	    // options = passes l, type
        //loading animation
        APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))
		var defaults = {
			 type:'radio'
			,l:'popular' //letter to filter by
		}
        options = $.extend({},defaults,options);
        $.when( Backbone.Radio.channel('entities').request('shows',options) ).done(function(data){ 
            APP.getView().showChildView('mainRegion', new pageView({
                collection:data
            }) )
        })
        
        var title;
        if(options.type==="radio"){
	        title = "Podcasts & On Demand Audio Programs"
        }else{
	        title = "Video Programs and Episodes"
        }
        window.document.title = title;
        if(typeof ga != "undefined"){ ga('send','pageview',{ title:title }) }
		if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': title }); }
        if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, title, '0', false, true); }
    }
    
    
    /***************************************
        VIEWS 
    ***************************************/

        //single item
        var programView = Marionette.View.extend({
             tagName:"div"
            ,className:"col-6 col-md-4 col-lg-3 pt8 border-b"
            ,template:_.template('<div class="row program"><div class="col-12 mb8"><a href="/<% if(type==="franchise"){ %>franchise<%}else{%>program<%}%>/<%-slug%>"><img alt="<%-title %>" style="width:100%" src="<%=images%>"/><% if(showDetail){ %><h1 class="m0 mt1 font-normal"><%=title%></h1></a><% if(desc_short){%><p class="font-light mb0"><%=desc_short%></p><%} }%></div></div>')
            ,templateContext:function(){
	            var img;	            
	            if(this.model.attributes.type==="tv"){
		       		img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"show-poster2x3"
			        });
			        
			        if(!img){ img = "/assets/imgs/tvplaceholder_Poster_480x720.jpg"; }
			    }else if(this.model.attributes.type==="franchise"){
				    img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"franchise-poster2x3"
			        });
	            }else{
		            img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"show-banner"
			        });
	            }
	            
	            //PBS sends huge images, but allows you to set whatever crop you want
		        if(img && img.indexOf("image.pbs.org") !== -1){
			        img += ".crop.300x450.jpg";
		        }
                
                return {
                     images: img
                    ,showDetail: (this.model.collection.state.l==="popular")?false:true
                }
            }
            ,events:{
                "click a": function(e){
                    e.preventDefault();
                    if(this.model.attributes.type==="franchise"){
	                    Backbone.Radio.channel('franchise').request('show',this.model.attributes.slug)
                    }else{
	                    Backbone.Radio.channel('shows').request('show',this.model.attributes.slug)
	                }
                }
            }
            ,onRender: function(){
	            //console.log(this.model.collection.state.l)
            }
        })
        var collectionView = Mn.CollectionView.extend({
             tagName: 'div'
            ,className:"row"
            ,childView: programView
        });
        
        
        // THE PAGE
        var pageView = Marionette.View.extend({
             template:_.template("<div><h1>Programs</h1></div><div class='pagingContainer'></div><div id='programsContainer'></div>")
            ,className:"page_programs_list py8"
            ,regions:{
                programs:{
                    el: '#programsContainer'
                }
                ,paging:{
                    el: '.pagingContainer'
                }
            }
            ,onRender: function() {
	            var that = this;
				$.when( that.collection.byLetter(that.collection.state.l) ).done(function(data){ 
		             that.showChildView('programs', new collectionView({
	                    collection: data
	                }));
	            })
                
                this.showChildView('paging', Backbone.Radio.channel('views').request('pagination-by-letter',{
					collection: this.collection
        		}));
            }
            ,onChildviewPageUpdated:function(e){
	            //console.log('onChildviewPageUpdated',e)
            }
        })
    
    return {
        show:show
    }
})()